import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { VerticalsService } from './verticals.service';


declare var $: any;

@Component({
  selector: 'app-verticals',
  templateUrl: './verticals.component.html',
  styleUrls: ['./verticals.component.scss']
})
export class VerticalsComponent implements OnInit {

  links : any[]=[];
  flag: string;
  name: any;
  filePath: any;

  constructor(private verticalServices : VerticalsService) { }

  ngOnInit(): void {
    this.onUpload();
    // ANIMATION

    $(document).ready(function($) {
  
      // Function which adds the 'animated' class to any '.animatable' in view
      var doAnimations = function() {
        
        // Calc current offset and get all animatables
        var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.animatable');
        
        // Unbind scroll handler if we have no animatables
        if ($animatables.length == 0) {
          $(window).off('scroll', doAnimations);
        }
        
        // Check all animatables and animate them if necessary
        $animatables.each(function(i) {
           var $animatable = $(this);
          if (($animatable.offset().top + $animatable.height() -1) < offset) {
            $animatable.removeClass('animatable').addClass('animated');
          }
        });
    
      };
      
      // Hook doAnimations on scroll, and trigger a scroll
      $(window).on('scroll', doAnimations);
      $(window).trigger('scroll');
    
    });

    //
    
  }

    
onUpload(): void {
    const data: any = {
      name: this.name,
      filePath: this.filePath,
      id: 0
    };
    this.verticalServices.getGoogleLinkDetails().subscribe(
      (response) => {
        this.links = response; 
      },
      (error) => {
        console.error('Error loading name', error);
      }
    );
  }

  loadLinks(): void {
    this.verticalServices.getGoogleLinkDetails().subscribe(
      (response) => {
        this.links = response;
      },
      (error) => {
        console.error('Error loading links', error);
      }
    );
  }
}
      